import firebase from "firebase";

var firebaseConfig = {
  apiKey: "AIzaSyA_-BbL6ywmnID4vrmeYO8YgGr_OBx2H1A",
  authDomain: "alvandir-gold-maquinas.firebaseapp.com",
  projectId: "alvandir-gold-maquinas",
  messagingSenderId: "391595658608",
  appId: "1:391595658608:web:7627ab0685f64b367f53b5",
  storageBucket: "gs://alvandir-gold-maquinas.appspot.com"
};

const fire = firebase.initializeApp(firebaseConfig);
const firebaseDatabase = firebase.database();
const firebaseStorage = firebase.storage();

export { fire, firebaseDatabase, firebaseStorage };
